import React from 'react'
import cookies from 'js-cookie'
import { sendDefaultEvent } from '../../../../../../components/analytics'
import { logError } from '../../../../../../components/toaster'
import { saveAs } from 'file-saver'
import { decorateFetch } from '../../../../../../api'
import { buildLibraryUsageQueryParams } from '../../../../../../graphql/schema/queries/library-usage-data'
import { LibraryUsageRequestProps } from '.'

export const buildDownloadURL = ({
  organizationID,
  applicationID,
  libraryHash,
  filters,
  sortingOrder
}: LibraryUsageRequestProps) => {
  const params = buildLibraryUsageQueryParams({
    filters,
    sortingOrder
  })

  return `/Contrast/api/ng/organizations/${organizationID}/applications/${applicationID}/libraries/${libraryHash}/reports/library-usage?${params}`
}

async function download({
  organizationID,
  applicationID,
  libraryHash,
  filters,
  sortingOrder
}: LibraryUsageRequestProps) {
  const decoratedFetch = decorateFetch(
    fetch,
    cookies,
    document.location,
    window.localStorage
  )

  let res: Response
  try {
    sendDefaultEvent('usage.panel.export.csv')

    res = await decoratedFetch(
      buildDownloadURL({
        organizationID,
        applicationID,
        libraryHash,
        filters,
        sortingOrder
      }),
      {
        method: 'GET',
        headers: {
          'Content-Type': 'text/csv'
        }
      }
    )
  } catch (e) {
    return logError('Failed to download file')
  }

  let filename = 'download'

  if (res) {
    if (!res.ok || res.status >= 400) {
      return logError('Failed to download file')
    }

    let blob: Blob
    try {
      blob = await res.blob()
    } catch (e) {
      return logError('Failed to download file')
    }

    const contentDisposition = res.headers.get('content-disposition')

    if (contentDisposition) {
      filename = parse(contentDisposition)
    }

    try {
      saveAs(blob, filename)
    } catch (e) {
      return logError('Failed to download file')
    }
  }
}

function parse(str: string) {
  str = str.slice('attachment; filename="'.length - 1)
  return str.slice(0, str.length)
}

export interface ChildProps {
  readonly download: (props: LibraryUsageRequestProps) => Promise<void>
}

interface Props {
  readonly children: (props: ChildProps) => React.ReactNode
}

export const LibraryUsageDownloader: React.FC<Props> = ({ children }) => {
  return <>{children({ download })}</>
}
